<template>
  <div class="progress-block">
    <vue-element-loading :active="isLoading"/>
    <div class="header flex-row">
      <span class="flex-expand block-vcenter padding-half">
        Остаток времени по специализациям для "{{ group.name }}"
      </span>
    </div>
    <table class="progress-table">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th v-for="specialization in specializations" :key="'specialization_' + specialization.id" v-bind:style="{'background-color': specialization.color, 'color': textColor(specialization.color)}">{{ specialization.name }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="g in groups" :key="'group_' + g.id">
          <td v-bind:style="{'background-color': group.color, 'color': textColor(g.color)}">{{ g.name }}</td>
          <td v-for="specialization in specializations" :key="'group_specialization_' + specialization.id" :class="cellColorClass(progressData[g.id][specialization.id] ? progressData[g.id][specialization.id].status : 999)">
            <span class="expected-hours" v-if="progressData[g.id][specialization.id]">
              {{ (progressData[g.id][specialization.id].expectedHours/8)|daysLeft }}
            </span>
          </td>
        </tr>
        <tr>
          <td>Всего</td>
          <td v-for="specialization in specializations" :key="'group_specialization_sum_' + specialization.id">
            {{ (summary[specialization.id]/8)|daysLeft }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import textColor from '@/utils/textColor'

import VueElementLoading from 'vue-element-loading'
import apiCall from "@/utils/api"

export default {
  name: 'GroupProgress',
  components: {
    VueElementLoading,
  },
  props: ['group'],
  data() {
    return {
      isLoading: false,
      progressData: {},
    }
  },
  computed: {
    ...mapGetters(["allSpecializations", "allUsersKeyed"]),
    groups() {
      let groups = this.group.groups.concat([this.group])
      return groups.filter(g => this.progressData[g.id] && Object.keys(this.progressData[g.id]).length)
    },
    specializations() {
      let specializationsIds = []
      for (const progressList of Object.values(this.progressData)) {
        specializationsIds = specializationsIds.concat(Object.keys(progressList))
      }
      return this.allSpecializations.filter(s => specializationsIds.includes(s.id+""))
    },
    summary() {  // данные для колонки "Всего"
      let summary = {}
      for (const specialization of this.specializations) {
        summary[specialization.id] = 0
      }
      for (const progressList of Object.values(this.progressData)) {
        for (const specializationId in progressList) {
          summary[specializationId] += progressList[specializationId].expectedHours
        }
      }
      return summary
    }
  },
  mounted() {
    this.isLoading = true
    this.loadProgress()
  },
  methods: {
    loadProgress() {
      apiCall({ url: 'task-groups/progress/'+this.group.id, method: "GET"})
			.then((resp) => {
				this.progressData = resp
        this.isLoading = false
			})
    },
    textColor(color) { return textColor(color) },
    cellColorClass(status) {
      switch (status) {
        case -50: // stopped
        case -20: // paused
          return 'failed'
        case 20: // in progress
          return 'waiting'
        case 90: // completed
          return 'done'
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>
.progress-block {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  background-color: #509E2F;
  color: #FFF;
  box-sizing: border-box;
  font-size: 1.39em;
  font-weight: 700;
}

.header .flex-expand {
  word-break: break-all;
}

.progress-table {
  border-collapse: collapse;
}
td, th {
  padding: .5rem;
  text-align: center;
  border: 1px solid #CCC;
}
td.unassigned {
  background-color: #EEEEEE;
}
td.failed {
  background-color: #FF7D70;
}
td.waiting {
  background-color: #FEF604;
}
td.done {
  background-color: #90C14B;
}
</style>